import { lazy } from 'react';
import PriceGroupForm from './PriceGroupForm';
import PriceGroupList from './PriceGroupList';

const PriceGroupConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/pricegroups',
            element: <PriceGroupList />,
        },
        {
            path: '/addpricegroup',
            element: <PriceGroupForm />,
        },
        {
            path: '/editPriceGrops/:id',
            element: <PriceGroupForm />,
        },
    ],
};

export default PriceGroupConfig;
